export default __webpack_public_path__ + "images/9ef058c1ead400db40240a02ca7a9405-menu-cat-play.svg";